import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

import { axios } from '@/library/axios';
import type { BaseResponse } from '@/types';

import type { GoldPriceRes } from './types';

// TODO: refactor this method to take gold weight as prop
const getGoldPrice = () => {
  return axios<GoldPriceRes, BaseResponse<GoldPriceRes>, void>({
    url: '/ltv-calculation?gold-weight=1',
    method: 'get',
  });
};

export const useLiveGoldPrice = () => {
  const [liveGoldPrice, setLiveGoldPrice] = useState<number>(0);

  const { data, isLoading, refetch, isSuccess } = useQuery({
    queryKey: ['live-gold-price'],
    queryFn: getGoldPrice,
    useErrorBoundary: false,
    refetchOnWindowFocus: false,
    retry: 3,
  });

  useEffect(() => {
    const resultData = data?.data.data;

    setLiveGoldPrice(resultData?.loanAmount || 0);
  }, [isSuccess]);

  return {
    liveGoldPrice,
    isLoading,
    refetch,
  };
};
